import { render, staticRenderFns } from "./ScientificDegreeForm.vue?vue&type=template&id=107f805b&"
import script from "./ScientificDegreeForm.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports